import React, { useEffect,useState } from 'react'
import {Button,Drawer, Empty,Spin,Card,Typography} from 'antd'
import common from '@/public/common'
import {numberFormat} from '@/utils'
import {useRequest} from 'ahooks'
import PropTypes from 'prop-types'
import styles from './OrderItem.module.less'
import moment from 'moment'
import {ORER_STATUS_MAP} from '../utils'
import _ from 'lodash'
import {getItemList} from '../service' 
import ProductItem from './ProductItem'
const { Paragraph } = Typography;
function OrderItem(props) {
  const {data,brandName} = props
  const [visible,setVisible] = useState(false)
  const [productList,setProductList] = useState([])
  const getData=(key,place,fn)=>{
    if((place&&typeof place!=='string')){
      return place(data[key])
    }else if(fn){
      return fn(data[key])
    }else{
      return _.get(data,key,place||'--')
    }
  }
  const {
    run:fetchGetItemList,
    loading:getItemListLoading
  } = useRequest (getItemList,
    {
      manual: true,
      onBefore:()=>{
      },
      onSuccess: (res) => {
        if(res){
          setProductList(res)
        }else{
          setProductList([])
        }
      },
      onFinally:()=>{
      }
    },
  );
  useEffect(()=>{
    if(visible){
      fetchGetItemList({
        order_code:getData('channel_order_code'),
        is_sigo_order:getData('sale_store_code') =='SigoWeb'
      })
    }
  },[visible])
  return (
    <div>
      <Card hoverable className={styles.OrderItem} >
        <div >
          <div className={styles.header}>
            {/* <span className={styles.left}>{`渠道订单：${getData('channel_order_code')}`}</span> */}
            <span className={styles.left}>
              渠道订单：
              <Paragraph ellipsis className={styles.orderCode} copyable>{`${getData('channel_order_code')}`}</Paragraph>
            </span>
            <span className={styles.tips}>{getData('order_status','default',(v)=>{
              if(v){
                return ORER_STATUS_MAP[v].title
              }
              return '--'
            })}</span>
          </div>
          <div className={styles.contents}>
            <section className={styles.imgWrap} onClick={()=>{setVisible(true)}}>
              <img src={getData('product_img')}></img>
              <span className={styles.tips}>共{getData('product_count')}件</span>
            </section>
            <div className={styles.detail}>
              <p className={styles.top}><span style={{fontSize:12}}>
                店铺：
              </span>{`${getData('channel_store')}`}</p>
              <span style={{fontWeight:600,fontSize:12}}>
                {`￥`}
                <span style={{fontSize:16}}>
                  {
                    getData('order_amt',(v)=>{
                      if(v){
                        return numberFormat(v,2)
                      }
                      return '--'
                    })
                  }
                </span>
              </span>
              <span><span style={{fontSize:12}}>
                付款时间：
              </span>{`${getData('pay_time',(v)=>{
                if(v){
                  return moment(v).format('MM-DD HH:mm:ss')
                }
                return '--'
              })}`}</span>
            </div>
          </div>
          <div>
            {/* <Button size='small' type="primary" onClick={()=>{window.open(`${common.oms_admin_url}main/order/orderdetail?FrontOrderCode=${getData('channel_order_code')}&OrderOperate=Read`)}} ghost>ERP订单</Button> */}
            <Button size='small' style={{fontSize:12}} type="primary" onClick={()=>{window.open(`http://oms.vsigo.cn/main/order/orderdetail?FrontOrderCode=${getData('channel_order_code')}&OrderOperate=Read`)}} ghost>查看ERP订单</Button>
          </div>
        </div>
      </Card>
      <Drawer
        // mask={false}
        style={{width:335}}
        height={600}
        placement={'bottom'}
        closable={false}
        onClose={() => { setVisible(false) }}
        visible={visible}
      >
        <Spin spinning={getItemListLoading}>
        {productList.length>0?
        productList.map((e,index)=>{
          return (
            <ProductItem brandName={brandName} key={index} data={e} sale_store_code={getData('sale_store_code')}></ProductItem>
            // <div className={} key={index}>
            //   <img></img>
            // </div>
          )
        })
        :<Empty></Empty>}
        <div>
          如有赠品，请去<a target='_blank' href={`http://oms.vsigo.cn/main/order/orderdetail?FrontOrderCode=${getData('channel_order_code')}&OrderOperate=Read`}>ERP后台</a>查看
        </div>
        </Spin>
      </Drawer>
    </div>
  )
}

OrderItem.propTypes = {
  brandName:PropTypes.string,
  data:PropTypes.object
}
OrderItem.defaultProps = {
  data:{},
  brandName:''
}
export default OrderItem



// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/OrderItem.js